package di

import analytics.AnalyticsBuildConfig
import analytics.AnalyticsConfig
import analytics.analyticsModule
import com.kinoshazam.Constants
import com.kinoshazam.analytics.NapierAnalyticsLogger
import com.kinoshazam.config.getPlatformConfig
import com.kinoshazam.crashreporting.NapierCrashReporterLogger
import com.kinoshazam.di.authModule
import com.kinoshazam.di.commonStateModule
import com.kinoshazam.di.coreModule
import com.kinoshazam.di.navigationModule
import com.kinoshazam.di.networkModule
import com.kinoshazam.di.storageModule
import com.kinoshazam.di.uiCoreModule
import com.kinoshazam.update.di.updateModule
import crashreporting.CrashReporterBuildConfig
import crashreporting.CrashReporterConfig
import crashreporting.crashreportingModule
import org.koin.core.KoinApplication
import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration

fun initKoin(enableNetworkLogs: Boolean = true, appDeclaration: KoinAppDeclaration = {}) =
    startKoin {
        appDeclaration()
        val platform = getPlatformConfig()
        val environment = if (Constants.IS_LOCAL_TEST) "local" else "prod"
        modules(
            platformModule()
                    + analyticsModule(
                AnalyticsConfig(
                    apiKey = AnalyticsBuildConfig.API_KEY,
                    host = AnalyticsBuildConfig.HOST,
                    appName = "kinoshka",
                    enabled = AnalyticsBuildConfig.API_KEY.isNotBlank(),
                    debug = enableNetworkLogs,
                    defaultProperties = mapOf(
                        "platform" to platform.platform.wireName,
                        "app_version" to platform.version,
                        "app_build" to platform.buildNumber,
                        "environment" to environment,
                    ),
                    logger = NapierAnalyticsLogger,
                )
            )
                    + crashreportingModule(
                CrashReporterConfig(
                    dsn = CrashReporterBuildConfig.DSN,
                    appName = "kinoshka",
                    enabled = CrashReporterBuildConfig.DSN.isNotBlank(),
                    debug = enableNetworkLogs,
                    environment = environment,
                    release = "kinoshka@${platform.version}",
                    dist = platform.buildNumber.toString(),
                    defaultTags = mapOf(
                        "platform" to platform.platform.wireName,
                        "app_version" to platform.version,
                    ),
                    logger = NapierCrashReporterLogger,
                )
            )
                    + commonModule()
                    + commonStateModule()
                    + networkModule(enableNetworkLogs = enableNetworkLogs)
                    + updateModule()
                    + authModule()
                    + coreModule()
                    + uiCoreModule()
                    + storageModule()
                    + navigationModule()
        )
    }

fun KoinApplication.Companion.start(): KoinApplication = initKoin { }
